<template>
    <kt-panel>
        <kt-panel-body v-if="gateways.length > 0">
            <form  id="update_general_subscription_setting_form">
                <kt-form-section>
                    <kt-row >
                        <kt-col  xs="12" sm="6" md="3" lg="3">
                            <kt-form-group>
                                <kt-form-label for="subscription_cost">
                                    {{ $t('application.subscription_cost') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" v-model="subscription_cost"
                                                 name="subscription_cost"
                                                 id="subscription_cost"
                                                 type="number"
                                ></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-form-action class="mt-4">
                            <kt-button
                                    class="m-2"
                                    size="md"
                                    variant="success"
                                    type="button"
                                    @click="updateSetting"
                                    id="update_general_subscription_setting_btn"
                            >
                                {{ $t('btn.update') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-row>
                </kt-form-section>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>
<script>
import {mapGetters} from "vuex";
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import {KTApp} from '@/plugins/core/app'
import {openBankingService} from '@/common/api.service'


export default {
    name: 'updateWalletSettings',
    data() {
        return {
            subscription_cost: 0
        }
    },
    computed: {
        ...mapGetters('collective', [
            'gateways'
        ]),
    },
    methods: {
        updateSetting(e) {
            let form = $('#update_general_subscription_setting_form')
            let btn = $('#update_general_subscription_setting_btn')
            KTApp.progress(btn)

            let params = {
                'subscription_cost': this.subscription_cost,
            }

            openBankingService.adminUpdateGeneralSubscriptionSetting(params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                    KTApp.unprogress(btn)
                }
            );
        },
    },
    mounted() {
        openBankingService.adminGetGeneralSubscriptionSetting().then(response => {
            this.subscription_cost = response.data.data.data.subscription_cost
        }).catch(({response}) => {
            this.showMsg(form, 'danger', response.data.message)
        })
    },
}
</script>
<style scoped>

</style>